import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "row m-4 mt-0"
}
const _hoisted_2 = { class: "col-sm-12" }
const _hoisted_3 = { class: "card card-body mb-0 text-center text-muted py-3" }
const _hoisted_4 = {
  key: 0,
  class: "row m-4 mt-0 mb-0"
}
const _hoisted_5 = { class: "col-sm-12" }
const _hoisted_6 = { class: "card card-body mb-0" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "form-group mb-0 col-md-3 col-lg-3 col-xl-2" }
const _hoisted_9 = { class: "row m-4 mt-0" }
const _hoisted_10 = { class: "card card-body mb-0 h-100" }
const _hoisted_11 = { class: "text-capitalize-first mb-3" }
const _hoisted_12 = {
  key: 0,
  class: "text-center text-muted py-3"
}
const _hoisted_13 = {
  key: 1,
  class: "overflow-auto"
}
const _hoisted_14 = { class: "table table-striped border-light align-middle text-left text-nowrap position-relative mb-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TeamLeadMultiselect = _resolveComponent("TeamLeadMultiselect")!
  const _component_LoaderWrapper = _resolveComponent("LoaderWrapper")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.accessDenied)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.helper.trans('statistic.dashboardPlus.access_denied')), 1)
          ])
        ]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (_ctx.isAdmin)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _createVNode(_component_TeamLeadMultiselect, {
                          multiple: false,
                          modelValue: _ctx.teamLeadFilter,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.teamLeadFilter) = $event))
                        }, null, 8, ["modelValue"])
                      ])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_9, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.blocks, (block) => {
              return (_openBlock(), _createElementBlock("div", {
                key: block.id,
                class: "col-lg-6 pe-lg-3 mb-3"
              }, [
                _createVNode(_component_LoaderWrapper, {
                  ref_for: true,
                  ref: (el) => _ctx.setLoader(block.id, el),
                  class: "h-100"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("h6", _hoisted_11, _toDisplayString(_ctx.helper.trans(`statistic.dashboardPlus.blocks.${block.id}`)), 1),
                      (!block.rows.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.helper.trans('statistic.dashboardPlus.empty')), 1))
                        : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                            _createElementVNode("table", _hoisted_14, [
                              _createElementVNode("thead", null, [
                                _createElementVNode("tr", null, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(block.columns, (column) => {
                                    return (_openBlock(), _createElementBlock("th", {
                                      key: column.key,
                                      class: _normalizeClass(["text-capitalize-first", column.align === 'end' ? 'text-end' : ''])
                                    }, _toDisplayString(_ctx.helper.trans(`statistic.dashboardPlus.columns.${column.key}`)), 3))
                                  }), 128))
                                ])
                              ]),
                              _createElementVNode("tbody", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(block.rows, (row, index) => {
                                  return (_openBlock(), _createElementBlock("tr", {
                                    key: `${block.id}-${row.traderId}-${index}`
                                  }, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(block.columns, (column) => {
                                      return (_openBlock(), _createElementBlock("td", {
                                        key: column.key,
                                        class: _normalizeClass(column.align === 'end' ? 'text-end' : '')
                                      }, _toDisplayString(column.value(row)), 3))
                                    }), 128))
                                  ]))
                                }), 128))
                              ])
                            ])
                          ]))
                    ])
                  ]),
                  _: 2
                }, 1536)
              ]))
            }), 128))
          ])
        ], 64))
  ]))
}